import { Controller } from '@hotwired/stimulus'
import { round } from '../../utils.js'

export default class extends Controller {
  static targets = ['discount', 'discountInfo', 'discard']

  connect() {
    if (Number(this.discountTarget.value) > 0) {
      this.discountTarget.disabled = true
    }
  }

  toggleDiscountRemove() {
    if (this.discardTarget.checked) {
      this.discountInfoTarget.classList.remove('hidden')
    } else {
      this.discountInfoTarget.classList.add('hidden')
    }
  }
}
